import { dashboardBFF } from "../axios-instances";
import { ReadingPerformance, ReadingPerformanceResponse } from "./types";
import { getServices } from "src/logs";

const { logger } = getServices();

export const getReadingPerformance = async (
  dateFrom: string,
  dateTo: string,
  logsDetailedFeature?: boolean | undefined
): Promise<ReadingPerformance> => {
  try {
    const uri = `api/performance/average?api-version=1.0&dateFrom=${encodeURIComponent(
      dateFrom
    )}&dateTo=${encodeURIComponent(dateTo)}`;

    // if ((.REACT_APP_ENVIRONMENT || "").toLowerCase() === "development") {
    //   console.log("getReadingPerformance:", uri);
    // }

    const response = await dashboardBFF.get(uri, { timeout: 3000 });

    // if ((process.env.REACT_APP_ENVIRONMENT || "").toLowerCase() === "development") {
    //   console.log("getReadingPerformance, response:", response.data as number);
    // }

    if (response.status === 204) {
      // no content
      const err = new Error("No content, http status code: 204");
      throw err;
    }

    if (logsDetailedFeature) {
      logger.logTrace({
        message: "getReadingPerformance - response",
        properties: {
          dateFrom: dateFrom.toString(),
          dateTo: dateTo.toString(),
          value: response.data.value.toString()
        }
      });
    }

    const responseData = response.data as ReadingPerformanceResponse;

    const readingPerf: ReadingPerformance = {
      value: responseData.value
    };

    return readingPerf;
  } catch (error) {
    const err = error as Error;
    if (!err.message.includes("204")) {
      logger.logError({
        message: "getReadingPerformance - Exception",
        properties: {
          name: err.name,
          message: err.message,
          stack: err.stack || "unknown stack",
          cause: String(err.cause ?? "unknown cause")
        }
      });
    }
    throw error;
  }
};

